import "./Home.module.css";
import MainHeader from "@/reusable_sections/Header";
import CreativeVision from "./sections/CreativeVision";
import TrustedByResearchers from "./sections/TrustedByResearchers";
import TheHeartBehindTheHealing from "./sections/TheHeartBehindTheHealing";
import Projectgallery from "./sections/Projectgallery";
import StimmenUnsererKunden from "./sections/StimmenUnsererKunden";
import BeginYourJourneyToBetterSleep from "./sections/BeginYourJourneyToBetterSleep";
import Footer from "@/reusable_sections/Footer";
import ServicesGrid from "./sections/ServicesGrid";
import WhyChooseFirststop from "./sections/WhyChooseFirststop";
export default function HomePage() {
  return <div>
      <MainHeader overlay />
      <CreativeVision />
      <TrustedByResearchers />
      <ServicesGrid />
      <TheHeartBehindTheHealing />
      <WhyChooseFirststop />
      <Projectgallery />
      <StimmenUnsererKunden />
      <BeginYourJourneyToBetterSleep />
      <Footer />
    </div>;
}